import { Program, Curriculum } from "../../../models/ISchema";
import { getSelectablePrograms } from "./filterAllPrograms";

type IOption = {
  label: string;
  value: string;
};

/**
 * Filters programs by campus, department, modality, and shift.
 * Delegates to getSelectablePrograms for cascading filter logic.
 */
export const filterByProgram = (
  programs: Program[],
  campus: IOption,
  department: IOption,
  modality: IOption,
  shift: IOption,
): Program[] => {
  return getSelectablePrograms(programs, campus, department, modality, shift, null);
};

export const filterByCurriculum = (
  programs: Program[],
  department: IOption,
  curriculums: Curriculum[],
  modality: IOption,
  shift: IOption,
): Curriculum[] => {
  // Filter programs by filters
  const selectablePrograms = getSelectablePrograms(
    programs,
    null,
    department,
    modality,
    shift,
    null,
  );

  // Filter result programs by shift
  const modalitiesIdsFromSelectablePrograms = selectablePrograms.map(program => program.id);

  const selectableCurriculums = curriculums.filter(item => {
    return modalitiesIdsFromSelectablePrograms.includes(item.program.id);
  });

  return selectableCurriculums;
};
